import { Action } from '@ngrx/store';

import {
    ChartsActionTypes,
    ChartsExpensesAna2Select,
    ChartsExpensesAna3Select,
    ChartsRevenueAna2Select,
    ChartsRevenueAna3Select,
    ChartsRevenueByCategorySelect,
    ChartsExpensesByCategorySelect,
} from './charts.actions';

export interface ChartsState {
    revenue?: {
        ana2?: {
            timeline: string;
            ana2Name: string;
        },
        ana3?: {
            ana3Name: string;
        }
    };
    expenses?: {
        ana2?: {
            timeline: string;
            ana2Name: string;
        },
        ana3?: {
            ana3Name: string;
        }
    };
    revenueByCategory: {
        customerCategory: string | null;
        timeline: string | null;
    };
    expensesByCategory: {
        providerCategory: string | null;
        timeline: string | null;
    };
}

export const initialChartsState: ChartsState = {
    revenue: {
        ana2: {
            timeline: undefined,
            ana2Name: undefined,
        },
        ana3: {
            ana3Name: undefined,
        }
    },
    expenses: {
        ana2: {
            timeline: undefined,
            ana2Name: undefined,
        },
        ana3: {
            ana3Name: undefined,
        }
    },
    revenueByCategory: {
        customerCategory: null,
        timeline: null,
    },
    expensesByCategory: {
        providerCategory: null,
        timeline: null,
    },
};

export function chartsReducer(state = initialChartsState, action: Action): ChartsState {
    let ana2: { ana2Name: string, timeline: string };
    let ana3: { ana3Name: string };
    switch (action.type) {
        case ChartsActionTypes.ChartsRevenueReset:
            return {
                ...state,
                revenue: initialChartsState.revenue,
                revenueByCategory: initialChartsState.revenueByCategory
            };
        case ChartsActionTypes.ChartsRevenueAna2Select:
            ana3 = state.revenue.ana3;
            ana2 = (action as ChartsRevenueAna2Select).payload;
            if (ana2.ana2Name !== state.revenue.ana2.ana2Name) {
                ana3 = initialChartsState.revenue.ana3;
            }
            return {
                ...state,
                revenue: {
                    ...state.revenue,
                    ana2: ana2,
                    ana3: ana3
                }
            };
        case ChartsActionTypes.ChartsRevenueAna3Select:
            return {
                ...state,
                revenue: {
                    ...state.revenue,
                    ana3: (action as ChartsRevenueAna3Select).payload
                }
            };       
        case ChartsActionTypes.ChartsRevenueReset:
            return {
                ...state,
                revenue: initialChartsState.revenue
            };
        case ChartsActionTypes.ChartsRevenueByCategorySelect:
            const { timeline, customerCategory } = (action as ChartsRevenueByCategorySelect).payload;
            return {
                ...state,
                revenueByCategory: {
                    ...state.revenueByCategory,
                    timeline,
                    customerCategory
                }
            };
        case ChartsActionTypes.ChartsExpensesReset:
                return {
                    ...state,
                    expenses: initialChartsState.expenses,
                    expensesByCategory: initialChartsState.expensesByCategory,
                };
        case ChartsActionTypes.ChartsExpensesAna2Select:
            ana3 = state.expenses.ana3;
            ana2 = (action as ChartsExpensesAna2Select).payload;
            if (ana2.ana2Name !== state.expenses.ana2.ana2Name) {
                ana3 = initialChartsState.expenses.ana3;
            }
            return {
                ...state,
                expenses: {
                    ...state.expenses,
                    ana2: ana2,
                    ana3: ana3
                }
            };
        case ChartsActionTypes.ChartsExpensesAna3Select:
            return {
                ...state,
                expenses: {
                    ...state.expenses,
                    ana3: (action as ChartsExpensesAna3Select).payload
                }
            };
        case ChartsActionTypes.ChartsExpensesByCategorySelect:
            const expCat = (action as ChartsExpensesByCategorySelect).payload;
            return {
                ...state,
                expensesByCategory: {
                    ...state.expensesByCategory,
                    timeline: expCat.timeline,
                    providerCategory: expCat.providerCategory
                }
            };
        default:
            return state;
    }
}

